import {updateField} from "vuex-map-fields";
import {CategoryEnum, TaskPriorityEnum, TaskTypeEnum} from "~/enums";
import {RunIntervalEnum} from "../enums";

const SET_GLOBAL_AUTOMATIONS = (state, globalAutomations) => {
  state.globalAutomations = globalAutomations;
};

const SET_FETCHING_GLOBAL_AUTOMATIONS = (state, value) => {
  state.fetchingGlobalAutomations = value;
};

const SET_AUTOMATIONS = (state, automations) => {
  state.automations = automations;
};

const SET_FETCHING_AUTOMATIONS = (state, value) => {
  state.fetchingAutomations = value;
};

const SET_GLOBAL_SEARCHES = (state, globalSearches) => {
  state.globalSearches = globalSearches;
};

const SET_FETCHING_GLOBAL_SEARCHES = (state, value) => {
  state.fetchingGlobalSearches = value;
};

const SET_UNCONFIGURED_GLOBAL_AUTOMATIONS = (state, unconfiguredGlobalAutomations) => {
  state.unconfiguredGlobalAutomations = unconfiguredGlobalAutomations;
};
const SET_FETCHING_UNCONFIGURED_GLOBAL_AUTOMATIONS = (state, value) => {
  state.fetchingUnconfiguredGlobalAutomations = value;
};
const SET_SEARCHES = (state, searches) => {
  state.searches = searches;
};

const SET_FETCHING_SEARCHES = (state, value) => {
  state.fetchingSearches = value;
};

const SET_AUTOMATION_ACTIONS = (state, automationActions) => {
  state.automationActions = automationActions;
};

const SET_FETCHING_AUTOMATION_ACTIONS = (state, value) => {
  state.fetchingAutomationActions = value;
};

const SET_SELECTED_AUTOMATION_ACTION_ID = (state, value) => {
  state.selectedAutomationActionId = value;
};

const SET_SELECTED_SEARCH_ID = (state, value) => {
  state.selectedSearchId = value;
};

const SET_SELECTED_AUTOMATION = (state, selectedAutomation) => {
  state.selectedAutomation = selectedAutomation;
};

const SET_SELECTED_GLOBAL_AUTOMATION = (state, selectedGlobalAutomation) => {
  state.selectedGlobalAutomation = selectedGlobalAutomation;
};

const SET_EXTENDING_SEARCHES = (state, extendingSearches) => {
  state.extendingSearches = extendingSearches;
};

const SET_FETCHING_EXTENDING_SEARCHES = (state, value) => {
  state.fetchingExtendingSearches = value;
};

const SET_SELECTED_EXTENDING_SEARCHES_IDS = (state, selectedExtendingSearchesIds) => {
  state.selectedExtendingSearchesIds = selectedExtendingSearchesIds;
};

const SET_DYNAMIC_EXTENDING_SEARCHES = (state, dynamicExtendingSearches) => {
  state.dynamicExtendingSearches = dynamicExtendingSearches;
};

const SET_FETCHING_DYNAMIC_EXTENDING_SEARCHES = (state, value) => {
  state.fetchingDynamicExtendingSearches = value;
};

const SET_SELECTED_DYNAMIC_EXTENDING_SEARCHES_IDS = (
  state, selectedDynamicExtendingSearchesIds,
) => {
  state.selectedDynamicExtendingSearchesIds = selectedDynamicExtendingSearchesIds;
};

const SET_PROCESS_TYPE = (state, processType) => {
  state.processType = processType;
};

const SET_CREATE_ACTIVE_STEP = (state, activeStep) => {
  state.activeStep = activeStep;
};

const SET_CREATING_AUTOMATION = (state, creatingAutomation) => {
  state.creatingAutomation = creatingAutomation;
};

const SET_PENDING_CONFIRMATION_COUNT = (state, pendingConfirmationCount) => {
  state.pendingConfirmationCount = pendingConfirmationCount;
};

const RESET_CREATING_AUTOMATION_TO_DEFAULT = (state) => {
  // reset the creatingAutomation to the default state
  state.creatingAutomation = {
    automation_action_id: undefined,
    search_id: undefined,
    dynamic_extending_search_ids: [],
    title: undefined,
    // FIXME creating after editing: type seems to be selected?
    type: undefined,
    description: undefined,
    run_interval: RunIntervalEnum.NEVER,
    is_recurring: false,
    temporary_exclude_recurring: false,
    temporary_exclude_recurring_duration: {
      days: undefined,
      weeks: undefined,
      months: undefined,
      year: undefined,
    },
    auto_process: false,
    needs_verification: false,
    visible_in_customer_portal: false,

    // signal
    create_signal: false,
    signal_title: null,
    signal_description: null,
    signal_assigned_users: [],
    signal_assigned_departments: [],

    // email campaign
    send_email: false,
    email_subject: null, // ?
    email_template_id: undefined,
    html_email_template_id: undefined,
    send_email_at_office_hours: true,
    email_account_id: undefined,

    // task settings
    create_task: false,
    task_type: TaskTypeEnum.GENERAL_TASK,
    task_title: null,
    task_description: null,
    task_priority: TaskPriorityEnum.NORMAL,
    task_category: CategoryEnum.CUSTOMER,
    task_assigned_users: [],
    task_assigned_user_departments: [],
    task_assigned_product_labels: [],
  };
};

const SET_FETCHING_CATEGORIES = (state, value) => {
  state.fetchingCategories = value;
};
const SET_CATEGORIES = (state, categories) => {
  state.categories = categories;
};
const SET_FETCHING_USERS = (state, value) => {
  state.fetchingUsers = value;
};
const SET_USERS = (state, users) => {
  state.users = users;
};
const SET_FETCHING_USER_DEPARTMENTS = (state, value) => {
  state.fetchingUserDepartments = value;
};
const SET_USER_DEPARTMENTS = (state, userDepartments) => {
  state.userDepartments = userDepartments;
};
const SET_FETCHING_TASK_TEMPLATES = (state, value) => {
  state.fetchingTaskTemplates = value;
};
const SET_TASK_TEMPLATES = (state, taskTemplates) => {
  state.taskTemplates = taskTemplates;
};
const SET_FETCHING_ME = (state, value) => {
  state.fetchingMe = value;
};
const SET_ME = (state, me) => {
  state.me = me;
};
const SET_FETCHING_AUTOMATION_RESULTS = (state, value) => {
  state.fetchingAutomationResults = value;
};

const SET_AUTOMATION_RESULTS = (state, automationResults) => {
  state.automationResults = automationResults;
};

const SET_AUTOMATION_RESULTS_PAGINATION = (state, pagination) => {
  state.automationResultsPagination = pagination;
};

const SET_SELECTED_AUTOMATION_RESULTS = (state, selectedAutomationResults) => {
  state.selectedAutomationResults = selectedAutomationResults;
};

const SET_AUTOMATION_RESULT_AS_PROCESSED = (state, automationResult) => {
  state.automationResults = state.automationResults.map((item) => {
    if (item.id === automationResult.id) {
      // eslint-disable-next-line no-param-reassign,no-undef
      item.processed_at = moment().toISOString();
    }
    return item;
  });
};

const SET_AUTOMATION_RESULT_AS_IGNORED = (state, automationResult) => {
  state.automationResults = state.automationResults.map((item) => {
    if (item.id === automationResult.id) {
      // eslint-disable-next-line no-param-reassign,no-undef
      item.ignored_at = moment().toISOString();
    }
    return item;
  });
};

const SET_SELECTED_GLOBAL_AUTOMATION_CONFIGURATION = (state, globalAutomationConfiguration) => {
  state.selectedGlobalAutomationConfiguration = globalAutomationConfiguration;
};

const SET_IGNORED_AUTOMATION_RESULTS = (state, ignoredAutomationResults) => {
  state.ignoredAutomationResults = ignoredAutomationResults;
};

const SET_FILTER = (state, filter) => {
  state.filter = filter;
};

const SET_FILTER_LOADED = (state, value) => {
  state.filterLoaded = value;
};

const SET_ACTIVE_AUTOMATIONABLES = (state, activeAutomationables) => {
  state.activeAutomationables = activeAutomationables.sort((a, b) => {
    if (a.model?.data?.pending_confirmation && !b.model?.data?.pending_confirmation) {
      return -1;
    }
    if (!a.model?.data?.pending_confirmation && b.model?.data?.pending_confirmation) {
      return 1;
    }
    return 0;
  });
};
const SET_INACTIVE_AUTOMATIONABLES = (state, inactiveAutomationables) => {
  state.inactiveAutomationables = inactiveAutomationables;
};

const SET_ONCE_AUTOMATIONABLES = (state, onceAutomationables) => {
  state.onceAutomationables = onceAutomationables;
};
const LOADING_ONCE_AUTOMATIONABLES = (state, value) => {
  state.loadingOnceAutomationables = value;
};
const LOADING_ACTIVE_AUTOMATIONABLES = (state, value) => {
  state.loadingActiveAutomationables = value;
};

const LOADING_INACTIVE_AUTOMATIONABLES = (state, value) => {
  state.loadingInactiveAutomationables = value;
};

const SET_SHOW_RESULT_CONFIRM_MODAL = (state, value) => {
  state.showResultConfirmModal = value;
};

const SET_FORM_DIRTY = (state, value) => {
  state.formDirty = value;
};

const SET_SELECTED_SORTING_CATEGORY = (state, category) => {
  state.selectedSortingCategory = category;
};

const SET_SHOW_EMAIL_AUTOMATIONS = (state, checked) => {
  state.showEmailAutomations = checked;
};

const SET_SHOW_SIGNAL_AUTOMATIONS = (state, checked) => {
  state.showSignalAutomations = checked;
};

const SET_SHOW_TASK_AUTOMATIONS = (state, checked) => {
  state.showTaskAutomations = checked;
};

const SET_SEARCH_QUERY = (state, query) => {
  state.searchQuery = query;
};

export default {
  LOADING_ONCE_AUTOMATIONABLES,
  SET_ONCE_AUTOMATIONABLES,
  SET_FORM_DIRTY,
  SET_SHOW_RESULT_CONFIRM_MODAL,
  LOADING_INACTIVE_AUTOMATIONABLES,
  LOADING_ACTIVE_AUTOMATIONABLES,
  SET_ACTIVE_AUTOMATIONABLES,
  SET_INACTIVE_AUTOMATIONABLES,
  SET_FILTER,
  SET_FILTER_LOADED,
  SET_GLOBAL_AUTOMATIONS,
  SET_FETCHING_UNCONFIGURED_GLOBAL_AUTOMATIONS,
  SET_UNCONFIGURED_GLOBAL_AUTOMATIONS,
  SET_IGNORED_AUTOMATION_RESULTS,
  SET_FETCHING_GLOBAL_AUTOMATIONS,
  SET_AUTOMATIONS,
  SET_FETCHING_AUTOMATIONS,
  SET_GLOBAL_SEARCHES,
  SET_FETCHING_GLOBAL_SEARCHES,
  SET_SEARCHES,
  SET_FETCHING_SEARCHES,
  SET_AUTOMATION_ACTIONS,
  SET_FETCHING_AUTOMATION_ACTIONS,
  SET_SELECTED_AUTOMATION_ACTION_ID,
  SET_SELECTED_SEARCH_ID,
  SET_SELECTED_AUTOMATION,
  SET_SELECTED_GLOBAL_AUTOMATION,
  SET_EXTENDING_SEARCHES,
  SET_FETCHING_EXTENDING_SEARCHES,
  SET_SELECTED_EXTENDING_SEARCHES_IDS,
  SET_PROCESS_TYPE,
  SET_DYNAMIC_EXTENDING_SEARCHES,
  SET_FETCHING_DYNAMIC_EXTENDING_SEARCHES,
  SET_SELECTED_DYNAMIC_EXTENDING_SEARCHES_IDS,
  SET_CREATE_ACTIVE_STEP,
  SET_CREATING_AUTOMATION,
  RESET_CREATING_AUTOMATION_TO_DEFAULT,
  SET_FETCHING_CATEGORIES,
  SET_CATEGORIES,
  SET_FETCHING_USERS,
  SET_USERS,
  SET_FETCHING_USER_DEPARTMENTS,
  SET_USER_DEPARTMENTS,
  SET_FETCHING_TASK_TEMPLATES,
  SET_TASK_TEMPLATES,
  SET_FETCHING_ME,
  SET_ME,
  SET_FETCHING_AUTOMATION_RESULTS,
  SET_AUTOMATION_RESULTS,
  SET_SELECTED_AUTOMATION_RESULTS,
  SET_AUTOMATION_RESULT_AS_PROCESSED,
  SET_AUTOMATION_RESULT_AS_IGNORED,
  SET_SELECTED_GLOBAL_AUTOMATION_CONFIGURATION,
  SET_AUTOMATION_RESULTS_PAGINATION,
  SET_PENDING_CONFIRMATION_COUNT,
  SET_SELECTED_SORTING_CATEGORY,
  SET_SHOW_EMAIL_AUTOMATIONS,
  SET_SHOW_SIGNAL_AUTOMATIONS,
  SET_SHOW_TASK_AUTOMATIONS,
  SET_SEARCH_QUERY,
  updateField,
};
